import { Alert } from '@acpaas-ui/react-components';
import _ from 'lodash';
import { getAnswersByField, getIntro } from '../../../lib/form.utils';
import QuestionnaireAnswer from './QuestionnaireAnswer';

const QuestionnaireAnswers = ({ className = '', answers, formSchema }) => {
  const answersByField = getAnswersByField(answers, formSchema);
  return (
    <div className={`spo-m-questionnaire-answers ${className}`}>
      {!_.isEmpty(formSchema) ? (
        <div dangerouslySetInnerHTML={{ __html: getIntro(formSchema) }}></div>
      ) : (
        <Alert type="danger" className="u-margin-bottom">
          Kan het formulier niet laden. Vind een momentopname van de antwoorden hieronder.
        </Alert>
      )}

      <div className="spo-m-questionnaire-answers__answers u-margin-top">
        {answersByField?.map((a) => <QuestionnaireAnswer key={a.uuid} {...a} />) ?? null}
      </div>
    </div>
  );
};

export default QuestionnaireAnswers;
